module.exports = __webpack_public_path__ + "img/1524241971.687ac12e.jpg";